import { computed } from 'mobx'
import { observer } from 'mobx-react-lite'
import { useContext } from 'react'
import cx from 'classnames'

import { ReactComponent as UndoIcon } from 'assets/icons/undoIconOnly24.svg'
import { undo } from 'prosemirror-history'
import { useEditorView } from 'common/Prose/EditorProvider/hooks/useEditorView'
import { Button } from 'components/Button'

import { AlmanacEditorStateContext } from 'stores/EditorState'

import Styles from '../MobileToolbar.module.scss'

interface Props {
  className?: string
}

export const UndoButton = observer(function UndoButton({ className }: Props) {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const almanacState = useContext(AlmanacEditorStateContext)!
  const view = useEditorView()

  const undoDisabled = computed(() => !almanacState.undoDepth).get()

  const handleUndo = () => {
    if (!undoDisabled) undo(view.state, view.dispatch)
    view.focus()
  }

  return (
    <Button
      preventFocusOnPress
      variant="none"
      size="sm"
      className={cx(Styles.button, {
        [Styles.disabled]: undoDisabled,
      })}
      onClick={handleUndo}
      aria-label="Undo button"
    >
      <UndoIcon />
    </Button>
  )
})
